import { createStyles } from '@mantine/styles';

var useStyles = createStyles((theme, { zIndex }) => ({
  root: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex
  }
}));

export default useStyles;
//# sourceMappingURL=Overlay.styles.js.map
